export const translations = {
  en: {
    // Navigation
    home: 'Home',
    management: 'Management',
    schedule: 'Schedule',
    appointment: 'Appointment',
    brandedapp: 'Branded App',
    shop: 'Shop',
    blog: 'Blog',
    help: 'Help Center',
    aboutus: 'About Us',
    faq: 'FAQ',
    contact: 'Contact',

    // Common
    learnMore: 'Learn More',
    getStarted: 'Get Started',
    bookNow: 'Book Now',
    tryFree: 'Try Free',

    // Homepage
    heroTitle: 'Professional Booking System for Your Business',
    heroSubtitle:
      'Streamline appointments, manage schedules, and grow your business with Omcean Booking - the complete solution for service-based businesses.',

    // Meta
    metaTitle: 'Professional Booking System',
    metaDescription:
      'Streamline your business with Omcean Booking. Professional appointment scheduling, customer management, and booking system for service businesses.',

    // Features
    featuresTitle: 'Everything You Need to Manage Your Business',
    featuresSubtitle: 'Powerful tools designed for modern service businesses',

    // Management
    managementTitle: 'Business Management Made Simple',
    managementDescription:
      'Comprehensive tools to manage your entire business operations',

    // Schedule
    scheduleTitle: 'Smart Scheduling System',
    scheduleDescription:
      'Intelligent scheduling that works around your availability',

    // Appointment
    appointmentTitle: 'Seamless Appointment Booking',
    appointmentDescription:
      'Let customers book appointments 24/7 with our intuitive system',

    // Branded App
    brandedAppTitle: 'Your Own Branded Mobile App',
    brandedAppDescription:
      'Custom mobile app with your branding for iOS and Android',

    // Shop
    shopTitle: 'Integrated E-commerce',
    shopDescription:
      'Sell products and services directly through your booking platform',

    // About Us
    aboutUsTitle: 'About Omcean Booking',
    aboutUsDescription:
      "We're dedicated to helping businesses succeed with powerful booking solutions",

    // FAQ
    faqTitle: 'Frequently Asked Questions',
    faqDescription: 'Find answers to common questions about our booking system',

    // Contact
    contactTitle: 'Get in Touch',
    contactDescription:
      'Contact Omcean Booking for support, demos, or questions about our appointment booking system. Our team is available 24/7 to help service businesses grow.',

    // Blog
    blogTitle: 'Booking System Tips & Business Insights',
    blogDescription:
      'Expert tips on booking systems, automation, and business growth. Discover strategies to optimize your service business with Omcean Booking insights.',
    readMore: 'Read More',
    backToBlog: 'Back to Blog',
    publishedOn: 'Published on',
    by: 'by',
    relatedPosts: 'You may also like',
    noPostsFound: 'No blog posts found',
    tags: 'Tags',

    // Help Center
    helpTitle: 'Help Center',
    helpDescription:
      'Find answers to your questions and get the most out of Omcean Booking',
    searchPlaceholder: 'Search for help articles...',
    searchResults: 'Search Results',
    allCategories: 'All Categories',
    noResults: 'No articles found',
    searchNoResults: 'No articles found for your search',
    category: 'Category',
    viewArticle: 'View Article',
    backToHelp: 'Back to Help Center',
    relatedArticles: 'Related Articles',
  },
  zh: {
    // Navigation
    home: '首頁',
    management: '業務管理',
    schedule: '智能排程',
    appointment: '線上預約',
    brandedapp: '品牌應用',
    shop: '商店',
    blog: '部落格',
    help: '幫助中心',
    aboutus: '品牌故事',
    faq: '常見問題',
    contact: '聯絡我們',

    // Common
    learnMore: '了解更多',
    getStarted: '立即開始',
    bookNow: '立即預約',
    tryFree: '免費試用',

    // Homepage
    heroTitle: '專業的商業預約系統',
    heroSubtitle:
      '使用 Omcean Booking 簡化預約流程、管理排程並發展您的業務 - 服務型企業的完整解決方案。',

    // Meta
    metaTitle: 'Omcean Booking - 專業預約系統',
    metaDescription:
      '使用 Omcean Booking 簡化您的業務。專業預約排程、客戶管理和服務企業預約系統。',

    // Features
    featuresTitle: '管理業務所需的一切',
    featuresSubtitle: '為現代服務業務設計的強大工具',

    // Management
    managementTitle: '簡化商業管理',
    managementDescription: '管理整個業務營運的綜合工具',

    // Schedule
    scheduleTitle: '智能排程系統',
    scheduleDescription: '智能排程系統，配合您的可用時間',

    // Appointment
    appointmentTitle: '無縫預約系統',
    appointmentDescription: '讓客戶透過我們直觀的系統24/7預約',

    // Branded App
    brandedAppTitle: '您專屬的品牌手機應用',
    brandedAppDescription: '為iOS和Android定制的品牌手機應用',

    // Shop
    shopTitle: '整合電子商務',
    shopDescription: '直接透過您的預約平台銷售產品和服務',

    // About Us
    aboutUsTitle: '關於 Omcean Booking',
    aboutUsDescription: '我們致力於透過強大的預約解決方案幫助企業成功',

    // FAQ
    faqTitle: '常見問題',
    faqDescription: '尋找有關我們預約系統的常見問題答案',

    // Contact
    contactTitle: '聯絡我們',
    contactDescription:
      '聯繫 Omcean Booking 獲取支援、產品演示或有關我們預約系統的問題。我們的團隊全天候為服務型企業提供協助，簡化您的排程管理流程。',

    // Blog
    blogTitle: '預約系統技巧與商業洞察',
    blogDescription:
      '預約系統、自動化和業務成長的專業技巧。探索優化服務業務的策略與 Omcean Booking 洞察。',
    readMore: '閱讀更多',
    backToBlog: '返回部落格',
    publishedOn: '發布於',
    by: '作者',
    relatedPosts: '你可能還喜歡',
    noPostsFound: '找不到部落格文章',
    tags: '標籤',

    // Help Center
    helpTitle: '幫助中心',
    helpDescription: '找到問題的答案，充分利用 Omcean Booking',
    searchPlaceholder: '搜尋幫助文章...',
    searchResults: '搜尋結果',
    allCategories: '所有分類',
    noResults: '找不到文章',
    searchNoResults: '沒有找到符合您搜尋的文章',
    category: '分類',
    viewArticle: '查看文章',
    backToHelp: '返回幫助中心',
    relatedArticles: '相關文章',
  },
} as const;

// Re-export types from centralized location
export type { Language, TranslationKey } from '@/types/language';

/**
 * Strips unused language content from an object based on key suffixes.
 * Keys ending in _en are cleared when language is 'zh'.
 * Keys ending in _cn are cleared when language is 'en'.
 * Arrays of objects are recursively processed.
 * Strings are replaced with empty strings.
 */
export function stripUnusedLanguage<T extends object>(
  obj: T,
  language: 'en' | 'zh'
): T {
  const result = { ...obj } as Record<string, unknown>;
  for (const key of Object.keys(result)) {
    const value = result[key];
    if (language === 'zh' && key.endsWith('_en')) {
      result[key] = Array.isArray(value) ? [] : '';
    } else if (language === 'en' && key.endsWith('_cn')) {
      result[key] = Array.isArray(value) ? [] : '';
    } else if (Array.isArray(value)) {
      // Recursively process arrays of objects
      result[key] = value.map(item =>
        typeof item === 'object' && item !== null
          ? stripUnusedLanguage(item, language)
          : item
      );
    }
  }
  return result as T;
}
